<template>
  <mm-tab-title>
      <div>
      <el-form ref="form" size="small" label-width="200px">
          <el-form-item label="otpauth-migration" prop="otpauthMigration">
		        <el-input type="textarea" placeholder="otpauth-migration://..." autofocus v-model.trim="afForm.otpauthMigration" :rows="8"></el-input>
          </el-form-item>
          <el-form-item label="">
            <div>
              <el-button slot="save" size="medium" type="primary" @click="submit">Set To Dict</el-button>
            </div>
          </el-form-item>
      </el-form>

      </div>
  </mm-tab-title>


</template>

<script>
import { GoogleAuthMigrationParser } from '@/lib/decodeGauth.js';
export default {
data() {
  return {
    afForm: {
      otpauthMigration: '',
    },
  };
},
methods: {
  async submit() {
    if (!this.afForm.otpauthMigration) {
      this.$message.error('otpauth-migration is required.');
      return;
    }
    const parser = new GoogleAuthMigrationParser();
    const info = await parser.decode(this.afForm.otpauthMigration);
    // console.log(info);
    const list = await this.$post('/dict/list', { where: { type: 'afSecret', label: { $in: info.map(acc => acc.name) } }, limit: info.length });
    console.log(list);
    const len = info.length;
    for (let i = 0; i < len; i++) {
      const acc = info[i];
      console.log(acc);
      const existing = (list.rows || []).find(item => item.label === acc.name);
      console.log('existing',existing)
      if (!existing) {
        await this.$post('/dict/create', {
          type: 'afSecret',
          label: acc.name,
          name: acc.secret,
        });
      } else {
        await this.$post('/dict/update', {
          _id: existing._id,
          label: acc.name,
          name: acc.secret,
          type: 'afSecret',
        });
      }
    }
    this.$message.success({
      dangerouslyUseHTMLString: true,
      message: `Successfully set ${info.length} accounts to dict.<br/>` + 
               info.map(acc => `Account: ${acc.name}`).join('<br/>')
    });
  },
},
};
</script>